import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { DropdownField, useControlledField } from '@frontend/design-system';
import { AxisOption } from './types';

export interface XAxisSelectorProps {
  options: AxisOption[];
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

export const XAxisSelector = ({ options, value, onChange, label = '' }: XAxisSelectorProps) => {
  const fieldProps = useControlledField({
    type: 'dropdown',
    value,
    onChange,
  });

  return (
    <DropdownField {...fieldProps} name='x-axis-selector' label={label} css={styles.dropdown}>
      {options.map((option) => (
        <DropdownField.Option key={option.value} value={option.value} css={styles.option}>
          {option.label}
        </DropdownField.Option>
      ))}
    </DropdownField>
  );
};

const styles = {
  dropdown: css({
    minWidth: 140,
    height: theme.spacing(4),
    fontSize: theme.fontSize(14),
    label: {
      fontSize: theme.fontSize(12),
    },
    p: {
      fontSize: theme.fontSize(14),
    },
  }),
  option: css({
    fontSize: theme.fontSize(14),
  }),
};
